import { SEARCH_RESULTS_MOVIES } from "../action/action-types";

export default function moviesSearch(state = { data: [] }, action){
    switch(action.type){
        case SEARCH_RESULTS_MOVIES:
            return { ...state, data: action.payload }
        default:
            return state
    }
}